import { Command } from 'common/Prose/Commands/types'
import { schema } from '../Schema'
import { ReplaceAroundStep } from 'prosemirror-transform'
import { Slice, Fragment } from 'prosemirror-model'

const MIN_LEVEL = 2
const MAX_LEVEL = 3

export const indentBy: (depth: number) => Command = (depth: number) => (state, dispatch) => {
  if (!dispatch) return false

  const { from, to } = state.selection
  const tr = state.tr

  state.doc.nodesBetween(from, to, (node, pos) => {
    if (node.type !== schema.nodes.heading) return
    const level = node.attrs.level
    if (level >= MIN_LEVEL && level <= MAX_LEVEL) {
      let newLevel = level + depth
      if (newLevel > MAX_LEVEL) {
        newLevel = MAX_LEVEL
      }
      if (newLevel < MIN_LEVEL) {
        newLevel = MIN_LEVEL
      }
      const slice = new Slice(Fragment.from(schema.nodes.heading.create({ level: newLevel })), 0, 0)
      const step = new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, slice, 1)
      tr.maybeStep(step)
    }
  })

  dispatch(tr)
  return true
}
